"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A `RpcLogger` that prints everything to `console`.
 */
class ConsoleRpcLogger {
    debug(logEntry) {
        console.log(logEntry.text, logEntry.exception);
    }
    warn(logEntry) {
        console.warn(logEntry.text, logEntry.exception);
    }
    trace(logEntry) {
        console.log(logEntry.text, logEntry.exception);
    }
}
exports.ConsoleRpcLogger = ConsoleRpcLogger;
//# sourceMappingURL=Logger.js.map